import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "extensionBar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ng-extend-logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://h01-release.storage.googleapis.com/explore.html",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "insert-logo",
      title: "Cave Explorer"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "insertNGTopBar",
  class: "flex-fill"
}, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 1,
  class: "nge-toolbar-icons"
}
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "loginRow" }
const _hoisted_8 = { class: "loginData" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "loginRow" }
const _hoisted_13 = { class: "loginData expired" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_visible = _resolveDirective("visible")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["LoginModal"]),
    _withDirectives(_createVNode($setup["VolumesOverlay"], {
      onHide: _cache[0] || (_cache[0] = $event => ($setup.showModal = false))
    }, null, 512 /* NEED_PATCH */), [
      [_directive_visible, $setup.showModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      ($setup.volumes.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = $event => ($setup.showModal = true))
          }, "Volumes (" + _toDisplayString($setup.volumes.length) + ")", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.toolbarDefs, (icon) => {
              return (_openBlock(), _createElementBlock("button", {
                key: icon.id,
                class: "nge-icon-btn",
                title: icon.label,
                onClick: $event => (icon.action())
              }, [
                (icon.svg)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: icon.svg
                    }, null, 8 /* PROPS */, _hoisted_6))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(icon.emoji), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createBlock($setup["DropdownList"], {
            key: 2,
            "dropdown-group": "extension-bar-right",
            id: "loginsDropdown",
            class: "rightMost"
          }, {
            buttonTitle: _withCtx(() => [
              _createTextVNode("Logins (" + _toDisplayString($setup.login.sessions.length) + ")", 1 /* TEXT */)
            ]),
            listItems: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.validLogins, (session) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, _toDisplayString(session.email), 1 /* TEXT */),
                      _createElementVNode("div", null, _toDisplayString(session.hostname), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "logoutButton",
                      onClick: $event => ($setup.logout(session))
                    }, _hoisted_11, 8 /* PROPS */, _hoisted_9)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invalidLogins, (session) => {
                return (_openBlock(), _createElementBlock("li", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", null, _toDisplayString(session.hostname) + " - Expired", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "logoutButton",
                      onClick: $event => ($setup.logout(session))
                    }, _hoisted_16, 8 /* PROPS */, _hoisted_14)
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}